export function attachmentSendFile(attachment) {
  if (!attachment?.documentId) return attachment?.file
  return Object.assign(attachment.file, { documentId: attachment.documentId })
}
